import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { Colors } from "../../../constants/Style";

export default makeStyles((theme: Theme) =>
  createStyles({
    buttonsContainer: {
      position: "absolute",
      right: 30,
    },
    button: {
      margin: "0 10px",
    },
    changesChip: {
      marginLeft: 10,
      color: Colors.White,
      backgroundColor: Colors.StatusYellow,
    },
  })
);
